import { render, staticRenderFns } from "./EventsBiddingApproval.vue?vue&type=template&id=158f03ee&scoped=true"
import script from "./EventsBiddingApproval.vue?vue&type=script&lang=js"
export * from "./EventsBiddingApproval.vue?vue&type=script&lang=js"
import style0 from "./EventsBiddingApproval.vue?vue&type=style&index=0&id=158f03ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158f03ee",
  null
  
)

export default component.exports